const ironAndFoldHouse = [
	{
		id: '3301',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Bed Sheet',
		category: 'Household',
		service: 'Iron And Fold',
		price: 30,
		quantity: 1
	},
	{
		id: '3302',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Pillow Case',
		category: 'Household',
		service: 'Iron And Fold',
		price: 10,
		quantity: 1
	},
	{
		id: '3303',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Towel',
		category: 'Household',
		service: 'Iron And Fold',
		price: 60,
		quantity: 1
	},
	{
		id: '3304',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Quilt',
		category: 'Household',
		service: 'Iron And Fold',
		price: 350,
		quantity: 1
	},
	{
		id: '3305',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Blanket (Single)',
		category: 'Household',
		service: 'Iron And Fold',
		price: 300,
		quantity: 1
	},
	{
		id: '3306',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Blanket (Double)',
		category: 'Household',
		service: 'Iron And Fold',
		price: 380,
		quantity: 1
	},
	{
		id: '3307',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Blanket Cover/ Bed Cover',
		category: 'Household',
		service: 'Iron And Fold',
		price: 45,
		quantity: 1
	},
	{
		id: '3308',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Curtain (Per ft Width)',
		category: 'Household',
		service: 'Iron And Fold',
		price: 7,
		quantity: 1
	},
	{
		id: '3309',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Table Cover / Sofa Cover / Chair Cover',
		category: 'Household',
		service: 'Iron And Fold',
		price: 15,
		quantity: 1
	}
];

export default ironAndFoldHouse;
